import { useSelector } from 'react-redux';
import { AirdropState, State } from '../types';

export const useAirdrop = (): AirdropState => {
  return useSelector((state: State) => state.airdrop)
}
